export const Label = ({
  label,
  description,
  className,
}: {
  label: string;
  description?: string;
  className?: string;
}) => {
  return (
    <div className={className}>
      <span
        className="label"
        dangerouslySetInnerHTML={{
          __html: label,
        }}
      />
      {description && <div>{description}</div>}
    </div>
  );
};
